import React from 'react';
import PropTypes from 'prop-types';
import ConnectedLogForm from './ConnectedLogForm';

// TODO: Move to react-viewerbase

function LogRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedLogForm />;
}

LogRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default LogRouting;
